// extracted by mini-css-extract-plugin
export default {"cls1":"NewsHeader-cls1__e1a4a79059a22eea1514","cls2":"NewsHeader-cls2___a692e4ce19fac969a98 NewsHeader-cls1__e1a4a79059a22eea1514"};